import React from 'react';
import { motion } from 'framer-motion';
import { AchievementRarity } from './types';
interface DjayIllustrationBaseProps {
  children: React.ReactNode;
  isUnlocked: boolean;
  rarity: AchievementRarity;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const SIZES = {
  sm: 'w-16 h-16',
  md: 'w-24 h-24',
  lg: 'w-full h-full max-w-[160px] max-h-[160px] aspect-square'
};
export function DjayIllustrationBase({
  children,
  isUnlocked,
  rarity,
  size = 'md',
  className = ''
}: DjayIllustrationBaseProps) {
  const sizeClass = SIZES[size];
  return <div className={`relative flex items-center justify-center ${sizeClass} ${className}`} data-id="element-4222" data-mp="34xm5x47z549h">
      {/* Locked State: Silhouette filter */}
      <motion.div className="w-full h-full relative z-10 rounded-2xl overflow-hidden" initial={false} animate={{
      filter: isUnlocked ? 'grayscale(0%) brightness(100%) drop-shadow(0 4px 6px rgba(0,0,0,0.1))' : 'grayscale(100%) brightness(30%) contrast(120%) drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
      opacity: isUnlocked ? 1 : 0.8
    }} transition={{
      duration: 0.5
    }} data-id="element-4223" data-mp="2vy8uw747c7mn">
        {children}
      </motion.div>

      {/* Locked State: Overlay Icon */}
      {!isUnlocked && <motion.div className="absolute inset-0 z-20 flex items-center justify-center pointer-events-none" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.2
    }} data-id="element-4224" data-mp="7h1pwuixslms">
          <div className="w-8 h-8 rounded-full bg-slate-800/80 border-2 border-slate-600 flex items-center justify-center backdrop-blur-sm" data-id="element-4225" data-mp="3pval2cv3zdwg">
            <svg className="w-4 h-4 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-4226" data-mp="3ku3eui8m6mrw">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-4227" data-mp="1057btklq8go7" />
            </svg>
          </div>
        </motion.div>}
    </div>;
}